import { type JSX, onMount } from "solid-js";

import { SEO_TDK_MAPPING } from "@/constants/seo";
import { SEO_ROUTES_TYPES } from "@/constants/seo-constants";
import { DefaultLocale } from "@/i18n/config";
import { getLocaleFromPath } from "@/lib/language";
import { MetaProvider } from "@solidjs/meta";

// MetaProvider
export function MetaProviderWrapper(props: { children: JSX.Element }) {
  return <MetaProvider>{props.children}</MetaProvider>;
}

// Main Content (Title, description...)
interface MetaTitleContainerProps {
  page: SEO_ROUTES_TYPES;
}

export function MetaTitleContainer(props: MetaTitleContainerProps) {
  const lang = getLocaleFromPath(window.location.pathname) || DefaultLocale;
  const page: SEO_ROUTES_TYPES = (props?.page as SEO_ROUTES_TYPES) || "home";
  const seoTDK = SEO_TDK_MAPPING?.[lang]?.[page];

  // 释放预设的
  onMount(() => {
    (globalThis as Record<string, unknown>).__SEO_CONFIG__ = null;

    // 移除 entry-server 给 爬虫的 的 SEO title 标签, 填补 title 标签给使用者动态看的
    if (typeof window !== "undefined") {
      document.title = seoTDK?.title || "";
    }
  });
  return null;
}

export const MetaTitle = {
  /* 首页 */
  Home: () => <MetaTitleContainer page={"home"} />,
  /* 菜单栏 */
  Menu: () => <MetaTitleContainer page={"menu"} />,
  /* 赌场 */
  Casino: () => <MetaTitleContainer page={"casino"} />,
  /* 积分游戏 */
  BonusGame: () => <MetaTitleContainer page={"bonus-game"} />,
  /* VIP */
  Vip: () => <MetaTitleContainer page={"vip"} />,
  /* 奖金中心 */
  BonusCenter: () => <MetaTitleContainer page={"bonus-center"} />,
  /* 投注比赛 */
  WagerContest: () => <MetaTitleContainer page={"wager-contest"} />,

  /* 收藏游戏 */
  FavoriteGames: () => <MetaTitleContainer page={"collections"} />,
  /* 热门游戏 */
  HotGames: () => <MetaTitleContainer page={"hot-game"} />,
  /* 最近游戏 */
  RecentGames: () => <MetaTitleContainer page={"recent-game"} />,
  /* 休闲游戏 */
  CasualGames: () => <MetaTitleContainer page={"casual-games"} />,

  /* 设置 */
  Settings: () => <MetaTitleContainer page={"settings"} />,
  /* 个人中心 - H5*/
  MyProfile: () => <MetaTitleContainer page={"my-profile"} />,
  /* 个人中心 - PC */
  Profile: () => <MetaTitleContainer page={"profile"} />,

  /* 通知 */
  Notify: () => <MetaTitleContainer page={"notify"} />,
  /* 反馈 */
  Feedback: () => <MetaTitleContainer page={"feedback"} />,
  /* 帮助 */
  Help: () => <MetaTitleContainer page={"help"} />,
  /* 负责任博彩 */
  Responsible: () => <MetaTitleContainer page={"responsible"} />,
  /* 安装页 */
  Install: () => <MetaTitleContainer page={"install"} />,

  /* 猜你喜欢 */
  PersonalizedGames: () => <MetaTitleContainer page={"personalized-game"} />,
  /* 厂商页面 */
  Providers: () => <MetaTitleContainer page={"providers"} />,

  /* V2 TDK 新增 */
  /* 代理 / 联盟计画 */
  Affiliate: () => <MetaTitleContainer page={"affiliate"} />,
  /* 活动页 */
  Promotion: () => <MetaTitleContainer page={"promotion"} />,
  /* 赞助页面 */
  Sponsorship: () => <MetaTitleContainer page={"sponsorship"} />,
  /* Nobru */
  Nobru: () => <MetaTitleContainer page={"nobru"} />,
  /* 重置密码 */
  Reset: () => <MetaTitleContainer page={"reset"} />,
  /* 奖金规则 */
  BonusRule: () => <MetaTitleContainer page={"bonus-rule"} />,
  /* 体育 */
  // Sports: () => <MetaTitleContainer page={"sports"} />,
  /* 投注详情 */
  // BetDetail: () => <MetaTitleContainer page={"bet-detail"} />,
  /* 个人化游戏 */
  // Personalized: () => <MetaTitleContainer page={"personalized"} />,

  /* -------------- 未 SEO 的页面 -------------- */
  /* 锦标赛 */ // 内容未新增
  Tournament: () => <MetaTitleContainer page={"tournament"} />,
  /* 钱包 */
  Wallet: () => <MetaTitleContainer page={"home"} />,
};
